import { dispatch } from '@rematch/core';

import {
    emailUnsubscribeService
} from '../../services/feathers.service';

const initialState = {
    emailUnsubscriptionData: {
        error: false,
        unsubscribedUserName: null,
        unsubscribedEntityName: null,
        status: null,
        message: null
    }
};

export default {
    state: initialState,
    reducers: {
        setEmailUnsubscriptionData(state, payload) {
            return {
                ...state,
                emailUnsubscriptionData: payload
            }
        },
        clear() {
            return initialState
        }
    },
    effects: {
        async unsubscribeEmail(payload) {
            try {
                let unsubscriptionResponse = await emailUnsubscribeService.create(payload);
                dispatch.unsubscribe.setEmailUnsubscriptionData(unsubscriptionResponse);
            } catch (err) {
                dispatch.unsubscribe.setEmailUnsubscriptionData(err);
                throw err;
            }
        }
    }
}